<div class="rs-wrapper-v4 grid col2 col1-sm">
    <div class="container-description-title">
        <h1>{{titleHero}}</h1>
        <p class="secondary-landing-system-text"
            *ngIf="system.relationships.system_information.data[0] && system.relationships.system_information.data[0].attributes">
            {{system.relationships.system_information.data[0].attributes.description}}</p>
    </div>

    <div class="container-combine-image">
        <ng-lottie [options]="lottieOptions"
            (animationCreated)="onAnimationLoaded($event)" (mouseenter)="animationReverse()" (mouseleave)="animationMove()"></ng-lottie>
        <div class="container-system-icon" (mouseenter)="animationReverse()" (mouseleave)="animationMove()">
            <app-system-icon systemId="{{system.id}}" title="{{system.attributes.name}}"
                alt="{{system.attributes.name}}" size="medium" width="128" height="128">
            </app-system-icon>
        </div>
    </div>
</div>
